import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useCopy } from '@/hooks/useCopy';

export function Forbidden() {
  const { t } = useCopy();
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Typography variant="h1" component="h1" gutterBottom>
          {t('errors.forbiddenTitle', 'Insufficient permissions')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t(
            'errors.forbiddenBody',
            "You don't have permission to view this. This action requires Super admin.",
          )}
        </Typography>
        <Box>
          <Button component={RouterLink} to="/" variant="contained">
            {t('nav.home', 'Home')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
